import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useMemo, useCallback } from "react";
import classnames from "classnames";
import DropdownSelect from "@/components/DropdownSelect";
import { useMatchMedia } from "@/hooks";
import dayjs from "@/lib/day";
import styles from "@/styles/DateTab.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DateTab(_ref) {
  var selectedDay = _ref.selectedDay,
      onClick = _ref.onClick;
  var mobileSize = useMatchMedia([{
    query: "screen and (max-width: 520px)",
    value: true
  }], false);
  var days = useMemo(function () {
    var now = dayjs();

    var range = _toConsumableArray(Array(8)).map(function (_, k) {
      return k;
    });

    return range.map(function (i) {
      var day = now.add(i, "day");
      return {
        text: i == 0 ? "本日" : day.format("M/D(dd)"),
        value: day.format("YYYY-MM-DD")
      };
    });
  }, []);
  var handleClick = useCallback(function (day) {
    return function () {
      if (onClick) {
        onClick(day);
      }
    };
  }, []);
  var handleSelect = useCallback(function (_ref2) {
    var value = _ref2.value;

    if (onClick) {
      onClick(value);
    }
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [!mobileSize && /*#__PURE__*/_jsx(_Fragment, {
        children: days.map(function (day) {
          return /*#__PURE__*/_jsx("div", {
            className: classnames(styles.tab, _defineProperty({}, styles.active, day.value === selectedDay)),
            onClick: handleClick(day.value),
            children: day.text
          }, day.value);
        })
      }), mobileSize && /*#__PURE__*/_jsx(DropdownSelect, {
        className: styles.dropdown,
        options: days,
        onSelect: handleSelect
      })]
    })
  });
}